module.exports = __webpack_public_path__ + "img/banner afbeelding courses.b1f5dff1.jpg";